import { apiSlice } from "../../apiSlice"

export const accountApiSlice = apiSlice.injectEndpoints({
    tagTypes: ["Account"],
    endpoints: builder => ({
        getAccounts: builder.query({
            query: () => `/Accounts?orderby=AccountId&top=10000`,
            providesTags: ["Account"],
        }),
        getAccountById: builder.query({
            query: (args) => {
                const accountId = args
                return {
                    url: `/Accounts/${accountId}`
                }
            },
            providesTags: ["Account"]
        }),
        addServiceToAccount: builder.mutation({
            query: ({ accountId, serviceId }) => ({
            url: `/Accounts/${accountId}/Service/${serviceId}`,
            method: 'PUT',
            }),
            invalidatesTags: ["Account"],
        }),
        removeServiceFromAccount: builder.mutation({
            query: ({ accountId, serviceId }) => ({
            url: `/Accounts/${accountId}/Service/${serviceId}`,
            method: 'DELETE',
            }),
            invalidatesTags: ["Account"],
        }),
    })
})

export const {
    useGetAccountsQuery,
    useGetAccountByIdQuery,
    useLazyGetAccountByIdQuery,
    useAddServiceToAccountMutation,
    useRemoveServiceFromAccountMutation,
} = accountApiSlice